import { Injectable } from '@angular/core';
@Injectable()
export class StorySearchParams {
    sortType: string;
    sortBy: string;
    sortOrder: string;
    start: number;
    rows: number;
}
